<template>
  <div class="nao-encontrada">
    <div class="nao-encontrada__icon-wrap">
      <v-icon color="#F27C00" size="44">mdi-map-marker-question-outline</v-icon>
    </div>
    <h1 class="nao-encontrada__title">Página não encontrada</h1>
    <p class="nao-encontrada__sub">
      O endereço que você abriu não existe ou foi alterado.
    </p>
    <v-btn color="#0052A0" rounded elevation="0" @click="voltar" class="px-6">
      <v-icon left small color="#FFD400">mdi-arrow-left</v-icon>
      <span style="color:#FFD400;font-weight:700;font-size:13px">Voltar ao início</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    voltar() {
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style scoped>
.nao-encontrada {
  min-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 16px;
  font-family: 'Inter', sans-serif;
}
.nao-encontrada__icon-wrap {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: #fff3e0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.nao-encontrada__title {
  font-size: clamp(1.15rem, 3.5vw, 1.5rem);
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
  max-width: 520px;
  margin: 0 0 8px;
}
.nao-encontrada__sub {
  font-size: 0.9rem;
  color: #64748b;
  max-width: 440px;
  margin: 0 0 24px;
}
</style>
